module.exports = __webpack_public_path__ + "static/img/会计引擎1.fb6a96ef.png";